'use client';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { PropsWithChildren } from 'react';
import { useTenant } from './tenant/TenantProvider';

const LightThemeProvider = ({ children }: PropsWithChildren) => {
  const { theme } = useTenant();
  return (
    <ThemeProvider theme={theme} defaultMode={'light'}>
      {children}
    </ThemeProvider>
  );
};

export default LightThemeProvider;
